module.exports = __webpack_public_path__ + "static/media/nswCusService.7b4c3e33.png";